import { render, staticRenderFns } from "./affair.vue?vue&type=template&id=087e9d47&scoped=true&"
import script from "./affair.vue?vue&type=script&lang=js&"
export * from "./affair.vue?vue&type=script&lang=js&"
import style0 from "./affair.vue?vue&type=style&index=0&id=087e9d47&scoped=true&lang=less&"
import style1 from "./affair.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e9d47",
  null
  
)

export default component.exports